<template>
    <div class="structure">
        <div class="container text-center">
          <h3 class="str-title">{{strtitle}}</h3>
          <p>{{strtext1}}</p>
          <p>{{strtext2}}</p>
          <p style="margin-bottom:20px;">{{strtext3}}</p>
          <div class="str-img" >
              <img src="@/assets/img/jiagou.jpg">
          </div>
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return {
           strtitle: 'iTrial Genies  -  为医药企业提供新一代的智能化临床研究解决方案',
           strtext1: '从项目管理层面，提供可视化的任务管理、进度管理、风险管理及成本管理',
           strtext2: '从数据管理层面，提供专业的SDC, EDC平台服务，提供基于业界实践的数字化平台服务，降本增效',
           strtext3: '支持I期~IV期项目，基于可信云的基础设施部署，安全可靠；遵循国内外行业主流标准，NMPA GCP规范',
           bannerimg: require('../../../assets/img/pro_bannerbg.jpg'),
        };
    },
}
</script>
<style scoped>
.project-banner{
  width: 100vw;
  height: 100vh;  
}
.bannertext{
  color:#fff;
  text-shadow: 0 0  3px #000;
  margin-bottom: 50px;
}
.str-title{
  font-weight: 600;
  margin:30px 0 10px;
}
.structure p{
  line-height: 30px;
}
.mr-30{
  margin-right: 30px;
}
.about-text{
  text-indent: 2em;;
}
.str-img img{
    max-width: 100%;
}
.str-img{
  margin-bottom: 20px;
}
.rx-title {
    margin: 20px 0 30px;
    font-weight: 600;
}
</style>